module.exports = __webpack_public_path__ + "assets/ellipsis-vertical-solid.424ebad6.svg";